import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import Swal from "sweetalert2";

export default function Termo() {
    const navigate = useNavigate();
    const location = useLocation();
    const { get, post, put } = useFetch();
    const { id1, id2 } = useParams();

    const [state, setState] = useState({
        acao: location.state?.acao || (id1 === "criar" ? "Criar" : "Visualizar"),
        termo1: { id_termo: "", palavra: "" },
        termo2: { id_termo: "", palavra: "" },
        loading: id1 !== "criar",
    });

    useEffect(() => {
        if (id1 === "criar") {
            setState(s => ({ ...s, acao: "Criar", loading: false }));
            return;
        }

        async function carregar() {
            try {
                let response = await get(`/termoiconografia/${id1}/${id2}`);
                if (response.status === 200 && response.result.data) {
                    const { Termo1, Termo2, id_termo1, id_termo2 } = response.result.data;
                    setState(s => ({
                        ...s,
                        termo1: { id_termo: id_termo1, palavra: Termo1?.palavra ?? "" },
                        termo2: { id_termo: id_termo2, palavra: Termo2?.palavra ?? "" },
                        loading: false,
                    }));
                } else {
                    setState(s => ({ ...s, loading: false }));
                    Swal.fire({ title: "Relação de termos não encontrada", icon: "error", confirmButtonColor: "#587b7f" });
                }
            } catch (error) {
                console.error("Erro no carregar():", error);
                setState(s => ({ ...s, loading: false }));
            }
        }
        carregar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id1, id2]);

    function changeTermo1(event) {
        const value = event.target.value;
        setState(s => ({ ...s, termo1: { ...s.termo1, palavra: value } }));
    }

    function changeTermo2(event) {
        const value = event.target.value;
        setState(s => ({ ...s, termo2: { ...s.termo2, palavra: value } }));
    }

    async function salvarTermo() {
        if (!state.termo1.palavra || !state.termo2.palavra) {
            Swal.fire({ title: "Preencha os dois termos", icon: "warning", confirmButtonColor: "#587b7f" });
            return;
        }
        if (state.termo1.palavra === state.termo2.palavra) {
            Swal.fire({ title: "Os termos precisam ser diferentes", icon: "warning", confirmButtonColor: "#587b7f" });
            return;
        }

        let method = state.acao === "Criar" ? post : put;
        let body = { palavra1: state.termo1.palavra, palavra2: state.termo2.palavra };

        try {
            let response;
            if (state.acao === "Criar") {
                response = await method(`/termoiconografia`, body);
            } else {
                response = await method(`/termoiconografia/${state.termo1.id_termo}/${state.termo2.id_termo}`, body);
            }

            if (response.status === 201 || response.status === 200) {
                Swal.fire({ title: "Termo salvo!", icon: "success", confirmButtonColor: "#587b7f" });
                navigate("/admin/iconografico/termos");
            } else if (response.status === 409) {
                Swal.fire({ title: "Não foi possível salvar os termos", text: "Já existe uma relação entre esses dois termos.", icon: "error", confirmButtonColor: "#587b7f" });
            } else if (response.status === 400) {
                Swal.fire({ title: "Não foi possível salvar os termos", text: response.result?.message ?? "", icon: "error", confirmButtonColor: "#587b7f" });
            } else {
                Swal.fire({ title: "Não foi possível salvar os termos", text: "Erro inesperado, tente novamente.", icon: "error", confirmButtonColor: "#587b7f" });
            }
        } catch (error) {
            console.error("Erro no salvarTermo():", error);
            Swal.fire({ title: "Erro de conexão", text: "Não foi possível falar com o servidor.", icon: "error", confirmButtonColor: "#587b7f" });
        }
    }

    if (state.loading) {
        return (
            <div className="admin-page-container text-center py-5">
                <div className="spinner-border text-teal"></div>
            </div>
        );
    }

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/iconografico/termos" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Termos
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Relação de Termo</h2>
                            <p className="admin-subtitle small mb-0">Vocabulário técnico do acervo iconográfico</p>
                        </div>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">* Termo Principal</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="input-moderno"
                                    placeholder="Ex: Estetoscópio"
                                    value={state.termo1.palavra ?? ""}
                                    onChange={changeTermo1}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={100}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">* Termo Relacionado (Sinônimo)</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="input-moderno"
                                    placeholder="Ex: Fonendoscópio"
                                    value={state.termo2.palavra ?? ""}
                                    onChange={changeTermo2}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={100}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvarTermo}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Alterações
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}
